var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table"},[_c('div',{staticClass:"table-head row"},_vm._l((_vm.columns),function(column,index){return _c('div',{key:index,staticClass:"table-head-cell"},[_vm._v(_vm._s(column))])}),0),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }